<app-column-title [column]="column"></app-column-title>

<div class="column-value">
  {{ getData | cxDate: 'longDate' }}
</div>
